import { PureQueryOptions } from '@apollo/client';
import React from 'react';
import ChipItem from './ChipItem';
import ChipListHeader from './ChipListHeader';
import { gqlTypes } from '../../types/gqlTypes';
import StatusTypeMap from './StatusTypeMap';
import styles from './ChipList.module.scss';
import EmptyChipList from './EmptyChipList';

export interface ChipListProps {
  chips: gqlTypes.miniChip[];
  statusTypeMap: StatusTypeMap;
  refetchQueries?: PureQueryOptions[];
  searchMode?: boolean;
  query?: string;
  showDateOwner?: boolean;
}

export default function ChipList({
  chips,
  statusTypeMap,
  refetchQueries,
  searchMode = false,
  query,
  showDateOwner = true,
}: ChipListProps) {
  return (
    <div className={styles.main}>
      <ChipListHeader searchMode={searchMode} showDateOwner={showDateOwner} />
      {chips.length === 0 ? (
        <EmptyChipList searchMode={searchMode} query={query} />
      ) : (
        <div>
          {chips.map((chip, i) => (
            <ChipItem
              chip={chip}
              statusType={statusTypeMap.get(chip.id)}
              key={i}
              refetchQueries={refetchQueries}
              searchMode={searchMode}
              showDateOwner={showDateOwner}
            />
          ))}
        </div>
      )}
    </div>
  );
}
